import React, { memo } from 'react'
import InputBase from '@mui/material/InputBase'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import Select from '@mui/material/Select'
import PropTypes from 'prop-types'
import { useScoreTierDropdown } from './ScoreTierDropdown.hooks'

const ScoreTierDropdown = props => {
	const [{ classes, value, scoreTiers }, { handleChange }] = useScoreTierDropdown(props)

	return (
		<FormControl id="dymanic-content-select">
			<Select
				className={classes.root}
				id="dymanic-content-select"
				value={value}
				onChange={handleChange}
				input={<InputBase />}
				fullWidth
				MenuProps={{
					classes: { paper: classes.paper, list: classes.list },
					anchorOrigin: {
						vertical: 'bottom',
						horizontal: 'left',
					},
					transformOrigin: {
						vertical: 'top',
						horizontal: 'left',
					},
					getContentAnchorEl: null,
				}}
				classes={{ root: classes.select, icon: classes.icon }}
			>
				{_.map(scoreTiers, tier => (
					<MenuItem className={classes.item} key={tier.id} value={tier.id}>
						<FiberManualRecordIcon className={classes.circle} style={{ color: tier.score_colour }} />
						<span className={classes.text}>{tier.name}</span>
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}

ScoreTierDropdown.propTypes = {
	onChange: PropTypes.func,
}

export default memo(ScoreTierDropdown)
